interface CoreJsShared {
    versions?: Array<{ version?: string; mode?: string }>;
}

const RECURSION_SIGNATURE = /Maximum call stack|_getOwnPropertyDescriptor/;
const MAX_WRAPPER_LENGTH = 200;
const MAX_SUSPECT_SCRIPTS_LENGTH = 300;

function safeRead<T>(read: () => T): Maybe<T> {
    try {
        return read();
    } catch {
        return undefined;
    }
}

// Диагностика платформенного краша «Maximum call stack» в core-js-обёртке Object.getOwnPropertyDescriptor: в additional кладём число копий core-js на странице, нативность метода и подозрительные скрипты, чтобы установить причину по реальным пользователям.
export function collectRecursionDiagnostics(error: unknown): Maybe<Record<string, string>> {
    try {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const signatureSource = error instanceof Error ? `${error.message} ${error.stack ?? ''}` : String(error);
        if (!RECURSION_SIGNATURE.test(signatureSource)) {
            return undefined;
        }

        const diagnostics: Record<string, string> = {};

        const coreJsShared = (window as unknown as { '__core-js_shared__'?: CoreJsShared })['__core-js_shared__'];
        const coreJsCopies = safeRead(() =>
            (coreJsShared?.versions ?? []).map((entry) => `${entry?.version ?? '?'}:${entry?.mode ?? '?'}`).join(', ')
        );
        diagnostics.recursionCoreJsCopies = coreJsCopies || 'none';

        const gopdSource = safeRead(() => Function.prototype.toString.call(Object.getOwnPropertyDescriptor));
        if (gopdSource !== undefined) {
            const isNative = gopdSource.includes('[native code]');
            diagnostics.recursionGopdNative = isNative ? 'yes' : 'no';
            if (!isNative) {
                diagnostics.recursionGopdWrapper = gopdSource.replace(/\s+/g, ' ').slice(0, MAX_WRAPPER_LENGTH);
            }
        }

        const scriptSources = safeRead(() =>
            Array.from(document.scripts, (script) => script.src).filter((src) => src.length > 0)
        );
        if (scriptSources !== undefined) {
            diagnostics.recursionHasExtension = scriptSources.some((src) => src.includes('-extension://'))
                ? 'yes'
                : 'no';
            const suspectScripts = scriptSources.filter((src) => /captchapgrd|mradx|naydex|-extension:\/\//.test(src));
            if (suspectScripts.length > 0) {
                diagnostics.recursionSuspectScripts = suspectScripts.join(' ').slice(0, MAX_SUSPECT_SCRIPTS_LENGTH);
            }
        }

        return diagnostics;
    } catch {
        return undefined;
    }
}
